<!-- MODAL devolverProduc -->
<div mdbModal #devolverProduc="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">

            <h4 class="modal-title w-100" id="myModalLabel">
                Devolver productos
            </h4>

            <h5  class="modal-title text-left" style="width:19%;">
              <b style="font-weight: 600;"> Nro Doc:{{nroFolioDoc}}</b>
            </h5>




                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="devolverProduc.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
               <div class="table-responsive">
                    <table class="table table-striped table-hover table-sm align-middle">
                        <thead class="grey lighten-2">
                            <tr>
                                <th scope="col">Código</th>
                                <th scope="col">Descripción</th>
                                <th scope="col" class="text-center">Cantidad</th>
                                <th scope="col">Formato</th>
                                <th scope="col" class="text-right">Total</th>
                                <th scope="col">Devolución</th>
                                <th scope="col">Motivo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="loading">
                                <td colspan="100%" style="text-align: center">
                                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                                </td>
                            </tr>
                            <tr *ngIf="!loading && listaProductos?.length === 0">
                                <td colspan="100%" style="text-align: center">
                                    No se encontró información
                                </td>
                            </tr>
                            <tr *ngFor="let producto of listaProductos">
                                <td>{{producto.sku}}</td>
                                <td>{{producto.descripcion_producto}}</td>
                                <td class="text-center">{{producto.cantidad | numerico}}</td>
                                <td>{{producto.formato_nombre}}</td>
                                <td class="text-right">{{producto.monto_total | numerico}}</td>
                                <td class="text-center">
                                    <div class="m-0" style="max-width: 50px;">
                                        <!-- <input value="" type="text" id="cantDevolucion" class="form-control"
                                                            placeholder="000" required #cantDevolucion onlyNumbers /> -->
                                        <input value="" type="text" id="devolucion" class="form-control" placeholder="000" required
                                            onlyNumbers min="0" [(ngModel)]="producto.additionalData.devolucion" name="devolucion"
                                            #devolucion="ngModel" (input)="devolucionChange(producto, $event.target.value)" />
                                        <mdb-error *ngIf="!producto.additionalData.devolucionValid">
                                            Cantidad no válida
                                        </mdb-error>
                                    </div>
                                </td>
                                <td>
                                    <div *ngIf="producto.additionalData.devolucion > 0" class="md-form m-0">
                                        <!-- <mdb-select [options]="optionsMotivo" placeholder="Motivo" [filterEnabled]="true">
                                                        </mdb-select> -->
                                        <mdb-select [options]="optionsMotivo" placeholder="Motivo" [filterEnabled]="true" required
                                            [(ngModel)]="producto.motivo_devolucion_especifico_codigo"
                                            name="motivo_devolucion_especifico_codigo" #motivo_devolucion_especifico_codigo="ngModel"
                                            (selected)="motivoEspecificoChange(producto, $event)">
                                        </mdb-select>
                                        <!-- && !motivo_devolucion_especifico_codigo.pristine -->
                                        <div *ngIf="!producto.additionalData.motivo_devolucion_especifico_codigoValid"
                                            style="color: #f44336;">
                                            Ingrese motivo</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                            *ngIf="listaProductos?.length > 0"></app-pagination>
                    </table>

               </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" size="sm" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
                    (click)="devolverProduc.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <div class="d-flex">

                    <div style="width: 200px;">
                        <mdb-select [options]="optionsMotivoGeneral" placeholder="Seleccionar motivo" [filterEnabled]="true"
                            [(ngModel)]="motivoGeneral" (selected)="motivoGeneralChange(motivoGeneral, listaProductos)">
                        </mdb-select>
                    </div>
                    <!-- <button *ngIf="listaProductos && listaProductos.length > 0" type="button"
                                        class="btn btn-success waves-light" mdbWavesEffect (click)="devolverProducto()">
                                        Confirmar
                                    </button> -->
                    <app-api-button [processing]="processing" (click2)="devolverProducto()"
                        *ngIf="listaProductos && listaProductos.length > 0">
                        Confirmar
                    </app-api-button>
                </div>



            </div>
        </div>
    </div>
</div>
